import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import { useEffect, useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
// import ReactTable from 'react-table';
import React from "react";
// import ReactDOM from "react-dom"
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// import { post } from 'jquery';

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1919() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear()+543)
    const [date1919data, setdate1919data] = useState([{ updateDate: '' }]);


    async function GetV1919() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1919", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow1919data(data.dataenum)
    }

    async function getdate() {
        const resdate1919 = await fetch("/api/BorrowReports/getdateV1919")
        const date1919data = await resdate1919.json();
        setdate1919data(date1919data.dataenum)
        console.log(date1919data)
    }

    const [Re1919yeardata, setRe1919yeardata] = React.useState([]);
    async function getR1919year() {
        const res = await fetch("/api/BorrowReports/getyear1919")
        const Re1919yeardata = await res.json()
        setRe1919yeardata(Re1919yeardata.dataenum)
        console.log(Re1919yeardata)
    }



    /*async function GetV1919() {
        const response1919 = await fetch("/api/BorrowReports/getV1919")
        const Borrow1919data = await response1919.json()
        setBorrow1919data(Borrow1919data.dataenum);
        
        console.log(Borrow1919data)
    }*/

    const [Borrow1919data, setBorrow1919data] = React.useState([])

    // const PrintPDF = () => {

    //     var tablebody = [[{ text: 'ปีงบประมาณที่กู้ยืมเงิน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สถานประกอบกิจการที่มีแผนการฝึกอบรม/ทดสอบ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สพร./สนพ. รายงานติดตามการฝึกอบรม', rowSpan: 2, colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'วิธีการติดตามการฝึกอบรมหรือทดสอบฯ', colSpan: 7, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}],
    //     [{}, {}, {}, {}, {}, { text: 'เข้าตรวจเยี่ยม', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผ่านโซเชียล', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ภาพถ่าย', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วีดีโอ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อื่นๆ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, {}, { text: 'ส่งรายงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ไม่ส่งรายงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'เฟสบุ๊ก', fillColor: '#cccccc', bold: true,  alignment: 'center' }, { text: 'ยูทูป', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สไกป์', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}]];
    //     Borrow1919data.forEach(function (item) {
    //         var rowdata = [{ text: 'ปีงบประมาณ ' + thYearSelected, alignment: 'left' }, { text: item.companyNo, alignment: 'right' }, { text: item.datePlan, alignment: 'center' }, { text: item.sent, alignment: 'right' }, { text: item.dontSent, alignment: 'right' }, { text: item.visit, alignment: 'right' }, { text: item.facebook, alignment: 'right' }, { text: item.youtube, alignment: 'right' }, { text: item.skype, alignment: 'right' }, { text: item.image, alignment: 'right' }, { text: item.video, alignment: 'right' }, { text: item.other, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'รายงานการติดตามการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานตามพระราชัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ.2545 และที่แก้ไขเพิ่มเติม ตามแบบ กย.8', bold: true, alignment: 'center', fontSize: 18 },
    //             Borrow1919data.map((item) => ({ text: [{ text: 'ประจำปีงบประมาณ พ.ศ. ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 }] })),
    //             {
    //                 table: {
    //                     widths: ['*', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    //                     body: tablebody

    //                 },
    //             }, { text: 'ข้อมูล ณ วันที่ ' + date1919data.updateDate, alignment: 'right' },
    //         ],

    //         defaultStyle: {
    //             font: 'THSarabunNew'

    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1919')
    // }

    useEffect(() => {
        GetV1919()
        getdate()
        getR1919year()
    }, [thYearSelected])
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ประจำปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "10%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1919yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {/* <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option> */}
                        {Re1919yeardata?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                     
                    </Input>
                </div>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1919?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1919?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                 <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1919?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1919?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>
                

                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="3" className='text-center'>
                                    ปีงบประมาณที่กู้ยืมเงิน
                                </th>
                                <th rowSpan="3" className='text-center'>
                                    จำนวน
                                </th>
                                <th rowSpan="3" className='text-center'>
                                    สถานประกอบกิจการที่มีแผนการฝึกอบรม/ทดสอบ
                                </th>
                                <th colSpan="2" rowSpan="2" className='text-center'>
                                    สพร./สนพ. รายงานติดตามการฝึกอบรม
                                </th>
                                <th colSpan="7" className='text-center'>
                                    วิธีการติดตามการฝึกอบรมหรือทดสอบฯ
                                </th>
                            </tr>
                            <tr>
                                <th rowSpan="2" className='text-center'>
                                    เข้าตรวจเยี่ยม
                                </th>
                                <th colSpan="3" className='text-center'>
                                    ผ่านโซเชียล
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ภาพถ่าย
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    วีดีโอ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    อื่นๆ
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    ส่งรายงาน
                                </th>
                                <th className='text-center'>
                                    ไม่ส่งรายงาน
                                </th>
                                <th className='text-center'>
                                    เฟสบุ๊ก
                                </th>
                                <th className='text-center'>
                                    ยูทูป
                                </th>
                                <th className='text-center'>
                                    สไกป์
                                </th>
                            </tr>
                        </thead>
                        <tbody> {Borrow1919data.map((item, i) => (
                            <tr>
                                <th scope="row" className='text-start'>
                                    ปีงบประมาณ {item.year}
                                </th>
                                <td className='text-end'>
                                    {item.companyNo}
                                </td>
                                <td className='text-center'>
                                    {item.datePlan}
                                </td>
                                <td className='text-end'>
                                    {item.sent}
                                </td>
                                <td className='text-end'>
                                    {item.dontSent}
                                </td>
                                <td className='text-end'>
                                    {item.visit}
                                </td>
                                <td className='text-end'>
                                    {item.facebook}
                                </td>
                                <td className='text-end'>
                                    {item.youtube}
                                </td>
                                <td className='text-end'>
                                    {item.skype}
                                </td>
                                <td className='text-end'>
                                    {item.image}
                                </td>
                                <td className='text-end'>
                                    {item.video}
                                </td>
                                <td className='text-end'>
                                    {item.other}
                                </td>
                            </tr>

                        ))}

                        </tbody>
                    </Table>
                </div>

                <tr className=' d-flex justify-content-end'>
                    ข้อมูล ณ วันที่ {date1919data.updateDate}
                </tr>

            </div>
        </Container>
    );
}